import theme from '../theme.json';
export function getTheme(database) {
    return function (schema, request) {
        return theme;
    };
}
